import { paragraphClassName, postMessageClassName } from './styles';

export interface Props {
  message?: string | null;
}

const CardPostMessage = ({ message }: Props) => {
  if (!message) {
    return null;
  }

  const formattedText = message.replace(/<[^>]*>?/gm, '').trim();

  return (
    <div className={postMessageClassName}>
      <p className={paragraphClassName}>{formattedText}</p>
    </div>
  );
};

CardPostMessage.displayName = 'CardPostMessage';

export default CardPostMessage;
